// utils/browserNotification/builders.ts - utils/browserNotification/notify.ts split (sub-module builders)
// Factory helpers untuk membangun payload notifikasi.

/**
 * Helper function to create notification from order data
 */
export function createOrderNotification(orderNumber: string, customerName: string, total: number) {
  return {
    title: '🛍️ Pesanan Baru!',
    body: `Order #${orderNumber} dari ${customerName} - Rp ${total.toLocaleString('id-ID')}`,
    tag: `order-${orderNumber}`,
    requireInteraction: true,
    data: {
      type: 'order',
      orderNumber,
    },
  };
}

/**
 * Helper function to create generic notification
 */
export function createGenericNotification(title: string, message: string, type?: string) {
  return {
    title,
    body: message,
    tag: `notification-${type || 'generic'}-${Date.now()}`,
    requireInteraction: false,
    data: {
      type: type || 'generic',
    },
  };
}
